import styled from 'styled-components';

export const InputBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px 0;
  width: 270px;
  max-width: 100%;

  &.view-jobs-field {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  label {
    padding: 0 0 5px;
    display: block;
  }
`;
